import React from 'react';
import cn from 'classnames';
import {Col} from 'reactstrap';
import {Row} from 'reactstrap';
import urlJoin from 'url-join';
import {Modal} from 'reactstrap';
import {Link} from 'react-router-dom';

import {CDN_IMAGE_URL} from 'configs';

import styles from './styles.module.scss';
import MuiIcon from 'components/Icons/MuiIcon';
import LockedFeatureModalV2Header from './LockedFeatureModalV2Header';
import LockedFeatureModalV2Actions from './LockedFeatureModalV2Actions';

const IMAGES = {
  snapshot: urlJoin(CDN_IMAGE_URL, `/vu/banners/free-user-companies.jpg`),
  market_intelligence: urlJoin(
    CDN_IMAGE_URL,
    'p',
    `landing/mi-data-visualization-1x.webp`
  ),
};

export const LOCKED_FEATURE_CONTENT_V2 = {
  snapshot: {
    close: true,
    title: <>Unlock Seamless Bulk Company Search</>,
    content: (
      <div className="text-secondary">
        <span>Subscribe now and have access to the following benefits:</span>
        <div className="d-flex">
          <MuiIcon name="check_circle" className="text-success mr-2" />
          <div>
            <strong className="text-dark">Upload Without Limit</strong>
            <p>Upload as many files as you need with no restrictions.</p>
          </div>
        </div>
        <div className="d-flex">
          <MuiIcon name="check_circle" className="text-success mr-2" />
          <div>
            <strong className="text-dark">Explore Data Summary</strong>
            <p>
              Gather insight from the result statistics using the standard
              report.
            </p>
          </div>
        </div>
        <div className="d-flex">
          <MuiIcon name="check_circle" className="text-success mr-2" />
          <div>
            <strong className="text-dark">Access Full Result</strong>
            <p>View complete company matches without missing any data.</p>
          </div>
        </div>

        <div className="d-flex">
          <MuiIcon name="check_circle" className="text-success mr-2" />
          <div>
            <strong className="text-dark">View Company Certificate</strong>
            <p>Instantly review certificates of matched companies.</p>
          </div>
        </div>
      </div>
    ),
  },
  market_intelligence: {
    close: true,
    backdrop: 'static',
    title: (
      <h className="font-weight-bold">
        Market Intelligence Bundle for Global Certification Insights
      </h>
    ),
    content: (
      <div className="text-secondary">
        <p>
          Get powerful insights with data from the{' '}
          <strong>IAF CertSearch database</strong>.
        </p>
        <div className="d-flex">
          <MuiIcon name="check_circle" className="text-success mr-2" />
          <div>
            <strong className="text-dark">IAF CertSearch Analytics:</strong>
            <p className="text-secondary">
              Flexible subscription plans for industry, government, academia,
              and enterprises. Track month-by-month trends, benchmarks, and
              activity across certifications, certification sites and certified
              entities.
            </p>
          </div>
        </div>
        <div className="d-flex">
          <MuiIcon name="check_circle" className="text-success mr-2" />
          <div>
            <strong className="text-dark">ISO Historical Data:</strong>
            <p className="text-secondary">
              Interactive charts the reveal long-term trends across certificates
              and certification sites moving beyond Excel to clear visual
              insights.
            </p>
          </div>
        </div>
        <p className="text-secondary">
          Together, these tools provide a complete view of the certification
          landscape, both current and historical, in one place. Visit{' '}
          <Link to="/services/certificate-market-intelligence">
            Market Intelligence
          </Link>{' '}
          to learn more.
        </p>
      </div>
    ),
  },
};

const Content = ({data, redirect, toggle, img, type, isOpen}) => {
  const {content, backdrop} = data || {}; // image

  return (
    <Modal
      centered
      isOpen={isOpen}
      backdrop={backdrop}
      toggle={() => toggle(type)}
      className={cn(styles['locked-modal-v2'])}
    >
      <Row centered="true">
        <Col
          lg={6}
          md={12}
          xl={7}
          className={cn('order-2 order-lg-1 p-4 p-lg-5')}
        >
          <LockedFeatureModalV2Header type={type} toggle={toggle} {...data} />

          <div>{content}</div>

          <LockedFeatureModalV2Actions
            type={type}
            toggle={toggle}
            redirect={redirect}
          />
        </Col>

        <Col
          md={12}
          lg={6}
          xl={5}
          className={cn(
            styles['locked-modal-v2__image-container'],
            'd-flex justify-content-center align-items-center'
          )}
        >
          <img
            src={img}
            className={cn(
              'img-fluid',
              styles['locked-modal-v2__image'],
              styles['locked-modal-v2__image__add-border']
            )}
            alt="illustration"
          />
        </Col>
      </Row>
    </Modal>
  );
};

const LockedFeatureModalV2 = (props) => {
  const {isOpen, type} = props;

  return (
    <Content
      type={type}
      isOpen={isOpen}
      img={IMAGES[type]}
      data={LOCKED_FEATURE_CONTENT_V2[type]}
      {...props}
    />
  );
};

export default LockedFeatureModalV2;
